import React from 'react';
import { Carousel, CarouselNavigation, CarouselSlide, CarouselWrapper } from '$partials/base/carousel';

import { Image } from '$partials/media';
import { formatPrice, formatRentFrequency, formatTagBanner } from '$utilities/format';
import { Tag } from '$partials/ui';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/partials/modules.d.ts').RelatedRentalPropertiesCarousel}
 */
const RelatedRentalPropertiesCarousel = ({
    title,
    carouselItems,
    currentPage
}) => {
    const filteredItems = currentPage ? carouselItems.filter(item => item.id !== currentPage.id) : carouselItems;
    const items = filteredItems.slice(0,6);

    if (!items.length) {
        return null;
    }

    return (
        <Carousel swiperConfig={{
            slidesPerView: 'auto',
            spaceBetween: 2,
            breakpoints: {
                640: {
                    slidesPerView: 'auto'
                },
                1024: {
                    slidesPerView: 'auto'
                }
            },
        }}>
            <div className='overflow-hidden featured-articles-carousel-container overhang-left sm-overhang-left-0 md-overhang-left-0'>
                <div className='col-12 flex items-center justify-between px5 md-px6 py5 md-py7 border-bottom grey bg-white'>
                    <h2 className='type-style-2 black'>{title}</h2>
                    <div className='hide md-show'>
                        <div className='flex flex-row items-center'>
                            <CarouselNavigation look='row'/></div>
                    </div>
                </div>
                <CarouselWrapper className='swiper-wrapper'>
                    {items?.map((item, i) => {

                        if (!item) { return null; }

                        const image = item.listingMedia?.[0]?.image;
                        const price = item.__typename === 'PropertyPage' ? formatPrice(item.priceGbp) : `${formatPrice(item.rentGbp)} ${formatRentFrequency(item.rentFrequency)}`;

                        return (
                            <CarouselSlide
                                className='flex carousel-slide'
                                index={i}
                                key={`highlights-carousel-${item.id}-${i}`}>
                                <a
                                    className='link-reset flex'
                                    href={item?.url}>
                                    {item.__typename === 'RentalPropertyPage' && (
                                        <div className='absolute top-0 ml5 md-ml6 mt5 md-mt6 z2'>
                                            <Tag title={formatTagBanner(item.publicSellingStatus, item.statusTag)}/>
                                        </div>
                                    )}
                                    {item.__typename === 'PropertyPage' && (
                                        <div className='absolute top-0 ml5 md-ml6 mt5 md-mt6 z2'>
                                            <Tag
                                                bgColor={item.publicSellingStatus === 'Sold' ? 'white' : 'yellow'}
                                                title={formatTagBanner(item.publicSellingStatus, item.statusTag)}/>
                                        </div>
                                    )}
                                    <div
                                        className='flex flex-col bg-white px5 md-px6 pt5 pb6 md-pt6 md-pb9 border-top grey carousel-item-fixed-height'>
                                        <div
                                            style={{
                                                width: `${(image?.width / image?.height)}em`
                                            }}>
                                            <div className='carousel-item-height'>
                                                <Image {...image}/>
                                            </div>
                                            <div className='mt5 sm-mt7 black'>
                                                <p className='type-style-5'>
                                                    {price}
                                                </p>
                                                <h3 className='type-style-3'>
                                                    {item?.heading}
                                                </h3>
                                                <div className='mt3'>
                                                    <p className='type-style-5'>{item?.propertyName}</p>
                                                    <p className='type-style-5'>{item?.area} {item?.outwardCode}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </CarouselSlide>
                        );
                    })}
                </CarouselWrapper>

            </div>
        </Carousel>

    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default RelatedRentalPropertiesCarousel;
